/**
 * Overrides default body style from _typography.scss or page layout
 */

.body {
  font-size: 16px;

  &.small {
    font-size: 12px;
    line-height: 16px;
    margin: 0;
  }
}

.center {
  text-align: center;
}

.left {
  text-align: left;
}

.right {
  text-align: right;
}
